<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <room-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import RoomForm from "./Form"
import model from "./model"

export default {
  components: { RoomForm },
  data() {
    return { model }
  },
}
</script>
